<template>
  <div v-if="category">
    <select
      class="input select"
      v-model="cate1">
      <option
        v-for="(cate, index) in category"
        :key="index"
        :value="cate.categoryId">
        {{ cate.categoryLabel[defaultLang] }}
      </option>
      <option value="call-staff">{{ locale['call-staff'] }}</option>
      <option value="unknown">unknown</option>
    </select>
    <select
      v-if="subCategory"
      class="input select"
      v-model="cate2">
      <option
        v-for="(cate, index) in subCategory"
        :key="index"
        :value="cate.categoryId">
        {{ cate.categoryLabel[defaultLang] }}
      </option>
    </select>
    <select
      v-if="subSubCategory"
      class="input select"
      v-model="cate3">
      <option
        v-for="(cate, index) in subSubCategory"
        :key="index"
        :value="cate.categoryId">
        {{ cate.categoryLabel[defaultLang] }}
      </option>
    </select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'

export default {
  name: 'ShopPageCateogry',
  props: [
    'locale',
    'categoryId',
    'category'
  ],
  components: {
  },
  computed: {
    defaultLang () {
      const langInfo = this.$store.state.setting.lang
      return langInfo.default
    },
    subCategory() {
      const mainCategory = this.category && this.category.find(x => x.categoryId === this.cate1)
      return mainCategory ? mainCategory.subCategory : null
    },
    subSubCategory() {
      const subCategory = this.subCategory && this.subCategory.find(x => x.categoryId === this.cate2)
      return subCategory ? subCategory.subCategory : null
    },
    isUnknown () {
      return this.categoryId === 'unknown'
    }
  },
  watch: {
    categoryId (categoryId) {
      const firstCategory = this.findFirstCategory()
      if (firstCategory) {
        this.cate1 = firstCategory.categoryId || ''
        if (firstCategory.subCategory && firstCategory.subCategory.length) {
          this.cate2 = categoryId || firstCategory.subCategory[0].categoryId
        }
      } else if (this.isUnknown) {
        this.cate1 = 'unknown'
      } else if (this.$route.params === 'call-staff') {
        this.cate1 = 'call-staff'
      }
    },
    cate1 (categoryId) {
      if (categoryId) {
        const mainCategory = this.category && this.category.find(x => x.categoryId === categoryId)
        if (mainCategory && mainCategory.subCategory && mainCategory.subCategory.length) {
          this.cate2 = mainCategory.subCategory[0].categoryId
        } else {
          this.cate2 = ''
          this.$router.replace({ params: { categoryId } })
        }
        this.cate3 = '' // 3뎁스 초기화
        
      }
    },
    cate2 (categoryId) {
      if (categoryId) {
        const subCategory = this.subCategory && this.subCategory.find(x => x.categoryId === categoryId)
        if (subCategory && subCategory.subCategory && subCategory.subCategory.length) {
          this.cate3 = subCategory.subCategory[0].categoryId
        } else {
          this.cate3 = ''
          this.$router.replace({ params: { categoryId } })
        }
      }
    },
    cate3 (categoryId) {
      if (categoryId) {
        this.$router.replace({ params: { categoryId } })
      }
    }
  },
  created () {
    const firstCategory = this.findFirstCategory()
    if (firstCategory) {
      this.cate1 = firstCategory.categoryId || ''
      if (firstCategory.subCategory && firstCategory.subCategory.length) {
        this.cate2 = firstCategory.subCategory[0].categoryId
      }
      this.$router.replace({
        params: {
          categoryId: firstCategory.subCategory && firstCategory.subCategory.length
            ? firstCategory.subCategory[0] && firstCategory.subCategory[0].subCategory && firstCategory.subCategory[0].subCategory.length
              ? firstCategory.subCategory[0].subCategory[0].categoryId
              : firstCategory.subCategory[0].categoryId
            : firstCategory.categoryId
        }
      })
    } else if (this.categoryId === 'call-staff') {
      this.cate1 = 'call-staff'
    } else if (this.isUnknown) {
      this.cate1 = 'unknown'
    }
  },
  data () {
    return {
      cate1: '',
      cate2: '',
      cate3: ''
    }
  },
  methods: {
    findFirstCategory () {
      const firstCategory = this.categoryId // 카테고리id가 있으면
        ? findTopParent(this.category, this.categoryId) // 1depth 카테고리
        : this.category[0] // 1depth의 0번째 카테고리
      function findTopParent(categories, targetId) {
        for (const category of categories) {
          if (category.categoryId === targetId) {
            return category; // 자기 자신이 최상위라면 그대로 반환
          }
          if (category.subCategory) {
            const found = findCategoryInSub(category, targetId)
            if (found) {
              return category // 최상위 부모 반환
            }
          }
        }
        return null
      }
      // 서브 카테고리에서 대상 찾기 (재귀)
      function findCategoryInSub(category, targetId) {
        if (category.categoryId === targetId) return category
        if (category.subCategory) {
          for (const sub of category.subCategory) {
            const found = findCategoryInSub(sub, targetId)
            if (found) {
              return found
            }
          }
        }
        return null
      }
      return firstCategory
    }
  }
}
</script>
